import React, { useState , useEffect } from 'react';
import './App.css';
import Bannercom from './components/Bannercom';
import Navbarcom from './components/Navbarcom';
import Skillscom from './components/Skillscom';
import Aboutcom from './components/Aboutcom'; 
import Contactuscom from './components/Contactuscom'; 
import Aos from 'aos';
import 'swiper/css';
import 'swiper/css/effect-cards';  
import 'aos/dist/aos.css';
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
function Homecomponent(){
   return(
    <div>
       <Bannercom />
             <Aboutcom />
             <Skillscom />
             <Contactuscom />
    </div>
   )
}

function App() {
  useEffect(()=>{
    Aos.init({
       duration:2000});
   }, []);
  return (
    <div className="bg-black">
 
      {/* <Bannercom></Bannercom>
      <Aboutcom></Aboutcom>
      <Skillscom></Skillscom>
      <Contactuscom></Contactuscom> */}
      <BrowserRouter>
      <Navbarcom></Navbarcom>
      <Routes>
        <Route>
          <Route path="/" element={<Homecomponent />} />
          <Route path="Skills" element={<Skillscom />} />
          <Route path="AboutMe" element={<Aboutcom />} />
          <Route path="ContactInfo" element={<Contactuscom />} />
        </Route>
      </Routes>
    </BrowserRouter>
    </div>
  );
}

export default App;
